import { useCallback } from 'react';
import { useAppDispatch } from '../../hooks/redux';
import { Account } from '../../types/AccountDefault.types';
import { getMyAccount } from '../../services/AccountDefaultService';
import {
  fetchAccountFailure,
  fetchAccountStart,
  fetchAccountSuccess
} from '../../store/slices/accountDefaultSlice';

export function useAccountDefault() {
  const dispatch = useAppDispatch();

  const fetchMyAccount = useCallback(async (): Promise<Account | null> => {
    dispatch(fetchAccountStart());
    try {
      const response = await getMyAccount();
      dispatch(fetchAccountSuccess(response.data));
      return response.data.account;
    } catch (error) {
      if (error instanceof Error) {
        dispatch(fetchAccountFailure(error.message));
      }
      return null;
    }
  }, [dispatch]);

  return {
    fetchMyAccount
  };
}
